import React from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from '@whitelabel/component-library';
import { ICustomer } from '../../helpers/types';
import { SITE_NAME, CONFIRMATION_EMAIL, UTM_SOURCE } from '../../helpers/constants';
import {
  updateCustomerGDPR as actionUpdateCustomerGDPR,
  updateBookingGDPR as actionUpdateBookingGDPR,
} from '../../actions';
import { StyledConsentBanner, StyledConsentBannerBox } from './styled';
import messages from './messages';

interface IConsentBannerProp {
  updateCustomerGDPR: (...args: any[]) => any;
  updateBookingGDPR: (...args: any[]) => any;
  customer?: ICustomer;
}

const ConsentBanner = ({ customer, updateCustomerGDPR, updateBookingGDPR }: IConsentBannerProp) => {
  const intl = useIntl();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const path = location.pathname;
  const ins = path.substring(path.lastIndexOf('/') + 1);

  return (
    <StyledConsentBannerBox>
      <StyledConsentBanner
        ButtonComponent={Button}
        disableStyles
        buttonText={intl.formatMessage(messages.acceptButtonText)}
        expires={365}
        onAccept={() => {
          if (customer) {
            updateCustomerGDPR(customer);
          } else if (path.includes('/pds/') && urlParams.get(UTM_SOURCE) === CONFIRMATION_EMAIL) {
            updateBookingGDPR(ins);
          }
        }}
      >
        <FormattedMessage
          {...messages.bannerText}
          values={{
            siteName: SITE_NAME,
            link: <Link to={`/${intl.locale}/privacy-policy`}>{intl.formatMessage(messages.linkText)}</Link>,
          }}
        />
      </StyledConsentBanner>
    </StyledConsentBannerBox>
  );
};

const mapDispatchToProps = {
  updateCustomerGDPR: actionUpdateCustomerGDPR,
  updateBookingGDPR: actionUpdateBookingGDPR,
};

export default connect(null, mapDispatchToProps)(ConsentBanner);
